<script lang="ts">import { cfgGoogleClientId, stateUi } from "@infinitro/config";
import { locale } from "@infinitro/global";
import { GoogleIcon } from "@infinitro/icons";
import { onMount } from "svelte";
import { onGoogleSignIn, stateGoogleToken } from "../state";
let showGoogle = false;
const onClick = (event) => {
	event?.preventDefault();
	event?.stopPropagation();
	showGoogle = true;
};
stateGoogleToken.subscribe((value) => {
	if (value) {
		showGoogle = false;
	}
});
onMount(() => {
	if (cfgGoogleClientId()) {
		console.log(`google authentication enabled`);
		window.onGoogleSignIn = onGoogleSignIn;
	}
});
$: useSolidStatic = $stateUi.button.buttonStyle === "solid-static";
$: useContrast = $stateUi.button.buttonStyle === "contrast";
$: useFlat = $stateUi.modal?.modalStyle === "flat";
</script>

<svelte:head>
	{#if cfgGoogleClientId()}
		<script src="https://accounts.google.com/gsi/client" async defer></script>
	{/if}
</svelte:head>

{#if cfgGoogleClientId()}
	<div
		id="g_id_onload"
		data-client_id={cfgGoogleClientId()}
		data-context="signin"
		data-ux_mode="popup"
		data-callback="onGoogleSignIn"
		data-itp_support="true"
		style="display: none"
	></div>

	{#if !showGoogle}
		<button
			class:button-solid-static={useSolidStatic || useContrast}
			class:button-contrast={useContrast}
			class:button-flat={useFlat}
			type="button"
			class="google"
			on:click={onClick}
		>
			<GoogleIcon className="google-icon" />
		</button>
	{/if}

	<div
		class="g_id_signin {showGoogle ? 'block' : 'hidden'}"
		data-type="standard"
		data-theme="outline"
		data-size="large"
		data-text="signin"
		data-locale={$locale}
	></div>
	<!-- data-width={146} fixes the button width but won't show user info if available -->
{/if}

<style>
	:global(.google-icon) {
		height: 1.5rem;
		width: 1.5rem;
}
	button {
		display: flex;
		height: 40px;
		width: 100%;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		padding-left: 0.25rem;
		padding-right: 0.25rem;
		padding-top: 1rem;
		padding-bottom: 1rem;
		text-align: center;
		background: var(--gradient-alternative-4);
}
	button:hover {
		border-color: var(--color-neutral-100);
}
	.button-solid-static {
		border-color: var(--color-accent-700);
		background-color: var(--color-secondary-500);
		background-image: unset;
}
	.button-contrast,
	.button-contrast:hover {
		border-width: 0px;
		background-color: var(--color-background-500);
		background-image: unset;
}

	.button-flat,
	.button-flat:hover {
		height: 48px;
		background: var(--color-background-500);
		border: 0;
		border-radius: 8px;
		background-image: none;
	}
</style>
